/**
 * ⏳ DATE LIMITE DE COLLECTE D'UN PROJET (champ finCollecte du catalogue, format « AAAA-MM-JJ »)
 * La collecte reste ouverte jusqu'à la fin de ce jour-là. Sans date (ou date invalide) : rien n'est affiché.
 */
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

const parseDay = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || '').trim());
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  const utc = Date.UTC(year, month - 1, day);
  const check = new Date(utc);
  // Refuse les dates impossibles (31 juin…)
  return check.getUTCMonth() === month - 1 && check.getUTCDate() === day ? { utc, year, month, day } : null;
};

/**
 * { endLabel, daysLeft, ended, label } ou null.
 * Les jours sont comptés en dates du calendrier (heure locale de l'appareil), pas en tranches de 24 h.
 */
export function collecteStatus(finCollecte, now = new Date()) {
  const end = parseDay(finCollecte);
  if (!end) return null;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const daysLeft = Math.round((end.utc - today) / 86400000);
  const endLabel = `${end.day === 1 ? '1er' : end.day} ${MOIS[end.month - 1]} ${end.year}`;
  const ended = daysLeft < 0;
  const label = ended
    ? `Collecte terminée le ${endLabel}`
    : daysLeft === 0
      ? 'Dernier jour de collecte'
      : `${daysLeft} jour${daysLeft > 1 ? 's' : ''} restant${daysLeft > 1 ? 's' : ''}`;
  return { endLabel, daysLeft: Math.max(daysLeft, 0), ended, label };
}
